import React, { Component } from 'react';
import { Button, ButtonType } from '@checkmarx/cx-ui';
import { LdapEditMode } from '../../../services/enums/ldap';

export default class LdapSaveButton extends Component {
    
    render() {

        const synchronazationStepNumber = 2;

        let submitButtonText = this.props.saveButtonText;

        if (this.props.mode == LdapEditMode.add) {
            
            if (this.props.currentStepNumber == synchronazationStepNumber) {
                
                submitButtonText = this.props.saveContinueButtonText;
            }
            else if (this.props.currentStepNumber == this.props.stepsLength) {
                
                submitButtonText = this.props.saveButtonText;
            }
            else {

                submitButtonText = this.props.continueButtonText;
            }
        }

        return (
            <Button 
                dataCy='ldap-save-button'
                className='edit-ldap-server-button'
                type='submit'
                text={submitButtonText}
                inProgress={this.props.inProgress}
            >
            </Button>
        );
    }
}